import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { api, endpoints } from "@/lib/api";

const COLOR_CLASS = {
  navy: "bg-[hsl(var(--surface-tint))] text-[hsl(var(--navy))]",
  orange: "bg-[hsl(var(--orange)/0.12)] text-[hsl(var(--orange))]",
  green: "bg-[hsl(var(--surface-tint-green))] text-[hsl(var(--green))]",
  blue: "bg-[hsl(var(--surface-tint))] text-[hsl(var(--navy-2))]",
};

export const ProgramsGrid = ({ limit }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.programs).then(setItems).catch(() => {}); }, []);
  const list = limit ? items.slice(0, limit) : items;
  return (
    <section id="programs" className="bg-background">
      <div className="container-wide py-16 lg:py-24">
        <SectionHeader eyebrow="Our Programs" title="12 focused programs, one mission." lead="Awareness leads. Action follows. Every program has a clear scope, measurable outcomes, and a named accountability lead." />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Sparkles;
            const color = COLOR_CLASS[p.color] || COLOR_CLASS.navy;
            return (
              <Reveal key={p.id} delay={i * 0.03}>
                <Link to={`/programs/${p.slug}`} className="group block rounded-xl border border-[hsl(var(--border))] bg-card overflow-hidden card-lift focus-ring" data-testid={`program-card-${p.slug}`}>
                  <div className="h-36 w-full overflow-hidden bg-[hsl(var(--surface-tint))]">
                    <img loading="lazy" src={p.image} alt={p.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
                  </div>
                  <div className="p-5">
                    <div className={`inline-flex h-9 w-9 items-center justify-center rounded-md ${color}`}><Icon className="h-4.5 w-4.5" /></div>
                    <h3 className="heading-3 mt-3 text-lg">{p.title}</h3>
                    <p className="text-sm text-[hsl(var(--muted-ink))] mt-2 line-clamp-3">{p.summary}</p>
                    <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--navy))]">Learn more <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
